(function () {
  'use strict';

  angular.module('app').component('invoicesPage', invoiceListCtrl());

  function invoiceListCtrl() {
    return {
      bindings: {},
      controller: InvoiceListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/invoices/invoices-page.component.html',
    };
  }

  InvoiceListCtrl.$inject = ['$location', 'UtilService', 'AbilityService', 'InvoiceService'];

  function InvoiceListCtrl($location, UtilService, AbilityService, InvoiceService) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = InvoiceService.getFilterCriteria();

    vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(vm.UtilService.startOfMonth());
    vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());
    // vm.filterCriteria.by_status = 'unpaid';

    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.permissions = {
      canCreate: AbilityService.can('create_invoice_accountadmin'),
    };

    // Methods
    vm.createInvoice = createInvoice;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      InvoiceService.getInvoices(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;
        vm.totalAmounts = data.totalAmounts;

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    }

    function createInvoice() {
      $location.path('/invoices/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/invoices/${item.id}`).search({ mode: mode });
    }
  }
})();
